<script>
import Drawer from "@/components/drawer";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import moment from "moment";

// Custom Components
import PageHeader from "@/components/page-header";
import BookingDetails from "@/components/booking-details.vue";
import UserService from "@/helpers/APIService/user.service";
import BookingService from "@/helpers/APIService/booking.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Booking Audit",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Drawer,
    DatePicker,
    BookingDetails,
  },
  props: {
    currentProps: Object,
  },
  data() {
    return {
      title: "Night Audit",
      table: {
        tableData: [],
        next: null,
        previous: null,
        count: 50,
        total_pages: 1,
        page_number: 1,
        per_page: 100,
        from: 1,
        to: 100,
      },
      query: "",
      buttonsArray: [],
      selectedType: "arrival",
      isButtonsShow: true,
      isDataLoading: true,
      pending_checkin_total: 0,
      pending_checkout_total: 0,
      in_house_list_total: 0,
      housekeeping_list_total: 0,
      total_no_show: 0,
      total_extend: 0,
      total_stay_guest: 0,
      cleanRoom: [],
      isSelectAll: false,
      selectedBooking: "",
      viewBookingDetails: false,
      auditDate: moment().format("YYYY-MM-DD"),
      nextAuditDate: moment().format("YYYY-MM-DD"),
      isBtnLoading: false,
    };
  },
  computed: {
    ...authComputed,
    bookingDetailsProps() {
      return {
        booking: this.selectedBooking,
      };
    },
  },
  mounted() {
    if (this.hotel.is_pms_connection) {
      this.getLatNightAuditData();
    } else {
      this.getBookingListTotal(
        `?business_date=${moment().format("YYYY-MM-DD")}`
      );
      this.getBookingListData(
        `?business_date=${moment().format("YYYY-MM-DD")}&booking_status=arrival`
      );
    }
    this.$root.$on("updateBookingStatus", (data) => {
      let type =
        data.bookingStatus == "checked_in"
          ? "arrival"
          : data.bookingStatus == "checked_out"
          ? "departure"
          : "no_show";
      this.maintainedButton(data.booking, type, "updateBookingStatus");
    });
  },
  methods: {
    // Method is use for get last night audit data
    async getLatNightAuditData() {
      const filter = "?ordering=-audit_date&size=1";
      BookingService.getNightAuditList(filter)
        .then((response) => {
          if (response.results.length !== 0) {
            this.auditDate =
              response.results.length !== 0
                ? response.results[0].next_audit_date
                : moment().format("YYYY-MM-DD");
            localStorage.setItem("last_audit", this.auditDate);
            this.$root.$emit("last_audit_update", this.auditDate);
            this.getBookingListTotal(
              `?business_date=${moment(this.auditDate).format("YYYY-MM-DD")}`
            );
            this.getBookingListData(
              `?business_date=${moment(this.auditDate).format(
                "YYYY-MM-DD"
              )}&booking_status=arrival`
            );
          } else {
            this.isDataLoading = false;
            localStorage.setItem("last_audit", moment().format("YYYY-MM-DD"));
            this.$root.$emit(
              "last_audit_update",
              moment().format("YYYY-MM-DD")
            );
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to get total
    async getBookingListTotal(query) {
      await BookingService.getBookingByFilterList(query)
        .then((response) => {
          this.pending_checkin_total = response.arrival;
          this.pending_checkout_total = response.departure;
          this.housekeeping_list_total = response.stay_over;
          this.in_house_list_total = response.stay_over;
          this.buttonsArray = [
            {
              text: `PENDING CHECK_IN (${this.pending_checkin_total})`,
              action: this.filterData,
              argument: "arrival",
              variant_outline: "outline-warning",
              variant: "warning",
            },
            {
              text: `PENDING CHECK_OUT (${this.pending_checkout_total})`,
              action: this.filterData,
              argument: "departure",
              variant_outline: "outline-warning",
            },
            {
              text: `INHOUSE LIST (${this.in_house_list_total})`,
              action: this.filterData,
              argument: "stay_over",
              variant_outline: "outline-success",
            },
            {
              text: `HOUSE KEEPING (${this.housekeeping_list_total})`,
              action: this.filterData,
              argument: "house_keeping",
              variant_outline: "outline-success",
            },
          ];
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for get data
    async getBookingListData(query) {
      this.isDataLoading = true;
      await BookingService.getBookingByFilterList(query)
        .then((response) => {
          if (response != null) {
            this.table.tableData = [];
            response.map((booking) => {
              let ago = "";
              ago = moment(booking.updated_at).fromNow(true);
              booking = { ...booking, ago };
              this.table.tableData.push(booking);
            });
          }
          this.table.next = response.next;
          this.table.previous = response.previous;
          this.table.count = response.count;
          this.table.total_pages = response.total_pages;
          this.table.page_number = response.page_number + 1;
          this.table.from = response.from;
          this.table.to = response.to;
          this.isDataLoading = false;
        })
        .catch((error) => {
          this.isDataLoading = false;

          errorHandler(error);
        });

      this.busy = false;
    },
    // Method is use for maintained avatar
    avatarGenerator(name) {
      return Middleware.avatarGenerator(name);
    },
    // Method is use for hide and show audit button
    toggleNightAudit() {
      this.isButtonsShow = !this.isButtonsShow;
    },
    // Method is use for filter data
    filterData(type) {
      this.selectedType = type;
      this.buttonsArray = this.buttonsArray.map((item) => {
        if (item.argument == type) {
          let str = item.variant_outline.replace("outline-", "");
          item = { ...item, variant: str };
        } else {
          if (item.variant !== undefined) {
            delete item.variant;
          }
        }
        return item;
      });
      if (type !== "house_keeping") {
        const query = `?business_date=${moment(this.auditDate).format(
          "YYYY-MM-DD"
        )}&booking_status=${type}`;
        this.getBookingListData(query);
        this.getBookingListTotal(
          `?business_date=${moment(this.auditDate).format("YYYY-MM-DD")}`
        );
      }
      if (type == "house_keeping") {
        const query = `?business_date=${moment(this.auditDate).format(
          "YYYY-MM-DD"
        )}&booking_status=stay_over`;
        this.isDataLoading = true;
        this.getBookingListData(query);
        this.getBookingListTotal(
          `?business_date=${moment(this.auditDate).format("YYYY-MM-DD")}`
        );
        this.busy = false;
      }
    },
    goNext(type) {
      type === "arrival"
        ? (type = "departure")
        : type == "departure"
        ? (type = "stay_over")
        : type == "stay_over"
        ? (type = "house_keeping")
        : (type = "arrival");
      this.filterData(type);
    },
    // Method is use for open booking details page
    openBookingDetails(data = null) {
      if (data != null) {
        this.selectedBooking = data;
      }
      this.viewBookingDetails = !this.viewBookingDetails;
    },
    // Method is use for maintain button
    maintainedButton(data, type, status) {
      if (type == "arrival") {
        this.openBookingDetails(data);
        this.total_stay_guest += data.total_guest;
        if (status == "updateBookingStatus") {
          this.table.tableData = this.table.tableData.filter(
            (item) => item.id !== data.id
          );
          this.pending_checkin_total !== 0
            ? (this.pending_checkin_total -= 1)
            : 0;
          this.buttonsArray = this.buttonsArray.map((item) => {
            if (item.argument == type) {
              item.text = `PENDING CHECK_IN (${this.pending_checkin_total})`;
            }
            return item;
          });
        }
      }
      if (type == "no_show") {
        this.openBookingDetails(data);
        this.total_no_show += 1;
        if (status == "updateBookingStatus") {
          this.table.tableData = this.table.tableData.filter(
            (item) => item.id !== data.id
          );
          this.pending_checkin_total !== 0
            ? (this.pending_checkin_total -= 1)
            : 0;
          this.buttonsArray = this.buttonsArray.map((item) => {
            if (item.argument == type) {
              item.text = `PENDING CHECK_IN (${this.pending_checkin_total})`;
            }
            return item;
          });
        }
      }
      if (type == "departure") {
        this.openBookingDetails(data);
        this.total_no_show += 1;
        if (status == "updateBookingStatus") {
          this.table.tableData = this.table.tableData.filter(
            (item) => item.id !== data.id
          );
          this.pending_checkout_total !== 0
            ? (this.pending_checkout_total -= 1)
            : 0;
          this.buttonsArray = this.buttonsArray.map((item) => {
            if (item.argument == type) {
              item.text = `PENDING CHECK_OUT (${this.pending_checkout_total})`;
            }
            return item;
          });
        }
      }
      if (type == "extend") {
        this.total_extend += 1;
        this.table.tableData = this.table.tableData.filter(
          (item) => item.id !== data.id
        );
        this.pending_checkout_total !== 0
          ? (this.pending_checkout_total -= 1)
          : 0;
        this.buttonsArray = this.buttonsArray.map((item) => {
          if (item.argument == type) {
            item.text = `PENDING CHECK_OUT (${this.pending_checkout_total})`;
          }
          return item;
        });
      }
    },
    // Method is use for add room to clean
    addToClean($evt, status) {
      if (status == "all") {
        if ($evt.target.value == "true") {
          this.table.tableData.map((item) => {
            this.cleanRoom.push(item.id);
          });
        } else {
          this.cleanRoom = [];
        }
      }
    },
    notBeforeToday(date) {
      return date <= new Date(new Date(this.auditDate).setHours(0, 0, 0, 0));
    },
    // Method is use for set next audit date
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (this.nextAuditDate !== "") {
        this.startNewDayAudit();
      } else {
        Middleware.notification("Please select next audit date !!", "info");
      }
    },
    openDateSelection() {
      this.$bvModal.show("audit-modal");
    },
    startNewDayAudit() {
      if (
        this.pending_checkin_total !== 0 ||
        this.pending_checkout_total !== 0
      ) {
        Middleware.notification(
          "Please complete pending checkin and checkout !!",
          "info"
        );
      } else {
        let finalObj = {
          hotel: this.hotel.id,
          audit_date: moment(this.auditDate).format("YYYY-MM-DD"),
          check_in: this.pending_checkin_total,
          check_out: this.pending_checkout_total,
          total_in_house: this.in_house_list_total,
          total_stay_guest: this.total_stay_guest,
          no_show: this.total_no_show,
          extend: this.total_extend,
          house_keeping: this.cleanRoom.length,
          next_audit_date: this.nextAuditDate,
        };
        Swal.fire({
          title: "Are you sure?",
          text: "You want start night audit!",
          icon: "info",
          showCancelButton: true,
          confirmButtonColor: "#238dfa",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Yes start it",
        }).then((result) => {
          if (result.value) {
            this.isBtnLoading = true;
            UserService.updateRoomStatus({ room_ids: this.cleanRoom });
            BookingService.nightAuditAdd(finalObj)
              .then((response) => {
                this.auditDate =
                  response !== null
                    ? response.next_audit_date
                    : moment().format("YYYY-MM-DD");
                localStorage.setItem("last_audit", this.auditDate);
                this.$root.$emit("last_audit_update", this.auditDate);
                Middleware.notification(
                  "Night audit done successfully !!",
                  "info"
                );
                this.$router.push({ path: "/booking" });
                this.isBtnLoading = false;
              })
              .catch((error) => {
                this.isBtnLoading = false;
                if (error.response.status == 400) {
                  if (
                    error.response.data.non_field_errors[0] !== undefined ||
                    null ||
                    ""
                  ) {
                    Middleware.notification(
                      "You have already audited for this date !!",
                      "info"
                    );

                    this.$bvModal.hide("audit-modal");
                  }
                }
                errorHandler(error);
              });
          }
        });
      }
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :multipleButtonDataInLeftSide="[
        {
          text: 'Night Audit',
          action: toggleNightAudit,
          variant_outline: 'danger',
        },
        ...buttonsArray,
      ]"
      :action="openDateSelection"
      text="Start New Day"
      :isButton="true"
    />
    <div class="row mt-2">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="table-responsive mb-0" v-dragscroll>
              <table
                class="table table-hover mb-0"
                ref="my-table"
                infinite-scroll-disabled="busy"
                infinite-scroll-distance="10"
              >
                <thead class="table-light">
                  <tr>
                    <th>Guest</th>
                    <th>Reference No</th>
                    <th v-if="selectedType !== 'house_keeping'">Source</th>
                    <th>Date</th>
                    <th>Rooms</th>
                    <th v-if="selectedType !== 'house_keeping'">Amount</th>
                    <th v-if="selectedType !== 'house_keeping'">Balance</th>
                    <th>ago</th>
                    <th>Status</th>
                    <th v-if="selectedType !== 'stay_over'">
                      <span v-if="selectedType == 'house_keeping'">
                        <input
                          class="form-check-input font-size-20 mt-0 me-2"
                          type="checkbox"
                          id="room_dirty"
                          v-model="isSelectAll"
                          :value="!isSelectAll"
                          @change="addToClean($event, 'all')"
                          checked
                        />
                        <label for="room_dirty" class="font-weight-bold"
                          >Room Dirty</label
                        >
                      </span>
                      <span v-else> Action </span>
                    </th>
                  </tr>
                </thead>
                <tbody
                  id="infinite-list"
                  v-if="table.tableData.length > 0 && !isDataLoading"
                >
                  <tr v-for="data in table.tableData" :key="data.reference_no">
                    <td>
                      <img
                        v-if="data.primary_guest.selfie_image != null"
                        class="rounded-circle picture-img"
                        :src="data.primary_guest.selfie_image"
                        alt="Avatar"
                      />
                      <span
                        v-if="data.primary_guest.selfie_image != null"
                        class="ms-1"
                        >{{ data.primary_guest.last_name + " " }}
                        {{ data.primary_guest.first_name }}</span
                      >
                      <div
                        v-if="data.primary_guest.selfie_image == null"
                        class="d-flex align-items-center"
                      >
                        <span
                          class="d-flex align-items-center justify-content-center avatar-md-title bg-soft bg-primary text-secondary font-20 rounded-circle picture-img"
                        >
                          {{
                            avatarGenerator(
                              data.primary_guest.first_name +
                                " " +
                                data.primary_guest.last_name
                            )
                          }}
                        </span>
                        <span class="ms-2">
                          {{ data.primary_guest.last_name }}
                          {{ data.primary_guest.first_name }}</span
                        >
                      </div>
                    </td>
                    <td>
                      <span
                        class="bookingRef"
                        v-if="data.booking_source_reference_no !== null"
                        >PMS {{ data.booking_source_reference_no }}</span
                      >
                      <br v-if="data.booking_source_reference_no !== null" />
                      <span
                        class="bookingRef"
                        v-if="data.ota_reference_no !== null"
                        >OTA {{ data.ota_reference_no }}</span
                      >
                      <br v-if="data.ota_reference_no !== null" />
                      <span class="bookingRef"
                        >Ref {{ data.reference_no }}</span
                      >
                    </td>
                    <td v-if="selectedType !== 'house_keeping'">
                      {{ data.booking_source.name }}
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        {{
                          global_format_date_and_time_custom(
                            data.check_in_date,
                            "DD MMM"
                          )
                        }}
                        <div class="night-border text-center mx-2">
                          <p
                            class="mb-0 badge-soft-info d-flex align-items-center justify-content-center"
                          >
                            {{ data.stay_night }}
                          </p>
                          <i class="fas fa-long-arrow-alt-right fs-3"></i>
                        </div>
                        {{
                          global_format_date_and_time_custom(
                            data.check_out_date,
                            "DD MMM"
                          )
                        }}
                      </div>
                    </td>

                    <td>
                      {{ data.total_room !== undefined ? data.total_room : 0 }}
                    </td>
                    <td v-if="selectedType !== 'house_keeping'">
                      {{ data.reservation_charge }}
                    </td>
                    <td v-if="selectedType !== 'house_keeping'">
                      {{ data.current_balance }}
                    </td>
                    <td>{{ data.ago }}</td>
                    <td>
                      <span
                        class="badge align-items-center py-1 px-2 card-badge"
                        :class="[
                          data.status === 'new_booking' ||
                          data.status === 'pre_checkin' ||
                          data.status === 'reservation' ||
                          data.status === 'pre_checked_done'
                            ? 'badge-soft-info'
                            : data.status === 'checked_in'
                            ? 'badge-soft-success'
                            : data.status === 'cancelled' ||
                              data.status === 'no_show'
                            ? 'badge-soft-danger'
                            : data.status === 'checked_out'
                            ? 'badge-soft-warning'
                            : 'badge-soft-secondary',
                        ]"
                      >
                        {{
                          data.status === "new_booking" ||
                          data.status == "pre_checkin"
                            ? "New Booking"
                            : data.status === "reservation"
                            ? "Reservation"
                            : data.status === "pre_checked_done"
                            ? "Pre Checked-In"
                            : data.status === "checked_in"
                            ? "Checked In"
                            : data.status === "checked_out"
                            ? "Checked Out"
                            : data.status === "cancelled"
                            ? "Cancelled"
                            : "No Show"
                        }}
                      </span>
                    </td>
                    <td v-if="selectedType !== 'stay_over'">
                      <b-button
                        variant="outline-secondary"
                        class="mx-1 btn-sm"
                        @click="maintainedButton(data, 'arrival')"
                        v-if="selectedType == 'arrival'"
                        >CHECK IN
                      </b-button>
                      <b-button
                        variant="outline-secondary"
                        class="mx-1 btn-sm"
                        @click="maintainedButton(data, 'no_show')"
                        v-if="selectedType == 'arrival'"
                        >NO SHOW
                      </b-button>
                      <b-button
                        variant="outline-secondary"
                        class="mx-1 btn-sm"
                        v-if="selectedType == 'departure'"
                        @click="maintainedButton(data, 'departure')"
                        >CHECK OUT
                      </b-button>
                      <b-button
                        variant="outline-secondary"
                        class="mx-1 btn-sm"
                        v-if="selectedType == 'departure'"
                        @click="maintainedButton(data, 'extend')"
                        >EXTEND
                      </b-button>
                      <div
                        class="form-check d-flex align-items-center mb-0 ms-3 ps-3"
                        v-if="selectedType == 'house_keeping'"
                      >
                        <input
                          class="form-check-input font-size-20 mt-0 me-2"
                          type="checkbox"
                          :id="data.id"
                          v-model="cleanRoom"
                          :value="data.id"
                          @change="addToClean($event)"
                        />
                        <label class="form-check-label">
                          {{ data.allotted_room.room_number }}
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="isDataLoading">
                  <tr v-for="number in 20" :key="number">
                    <td
                      class="placeholder-glow"
                      v-if="selectedType !== 'house_keeping'"
                    >
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td
                      class="placeholder-glow"
                      v-if="selectedType !== 'house_keeping'"
                    >
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td
                      class="placeholder-glow"
                      v-if="selectedType !== 'house_keeping'"
                    >
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td
                      class="placeholder-glow"
                      v-if="selectedType !== 'stay_over'"
                    >
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                    <td class="placeholder-glow">
                      <span class="placeholder w-100 placeholder-lg"></span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="!isDataLoading && table.tableData.length == 0">
                  <tr>
                    <td colspan="12" class="text-center">
                      <img
                        src="@/assets/images/empty.svg"
                        class="img-fluid"
                        alt=""
                      />
                      <p>
                        <span class="text-secondary">No Data Found</span>
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div
          class="d-flex justify-content-center mb-3"
          v-if="selectedType !== 'house_keeping'"
        >
          <b-button
            variant="danger"
            class="mx-1"
            @click="goNext(selectedType)"
            :disabled="
              (selectedType == 'arrival' && pending_checkin_total !== 0) ||
              (selectedType == 'departure' && pending_checkout_total !== 0)
            "
            >NEXT >>
            {{
              selectedType == "arrival"
                ? "PENDING CHECK-OUT"
                : selectedType == "departure"
                ? "IN HOUSE"
                : "HOUSE KEEPING"
            }}
            ({{
              selectedType == "arrival"
                ? this.pending_checkout_total
                : selectedType == "departure"
                ? this.in_house_list_total
                : this.housekeeping_list_total
            }})</b-button
          >
        </div>
      </div>
    </div>
    <!-- Method is use for open booking details drawer -->
    <Drawer
      @close="openBookingDetails"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1240"
      class="w-100"
    >
      <div v-if="viewBookingDetails">
        <BookingDetails :currentProps="bookingDetailsProps" />
      </div>
    </Drawer>
    <!-- Model is for select next audit date -->
    <b-modal
      id="audit-modal"
      centered
      title="Select Next Audit Date"
      hide-footer
      title-class="font-18"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label-for="date-input">
          <date-picker
            lang="en"
            placeholder="Select date"
            type="date"
            value-type="format"
            v-model="nextAuditDate"
            :disabled-date="notBeforeToday"
          ></date-picker>
        </b-form-group>
        <b-button
          class="float-end mt-2"
          variant="outline-primary"
          @click="handleOk"
          :disabled="isBtnLoading"
          ><i
            v-if="isBtnLoading"
            class="bx bx-loader bx-spin font-size-16 align-middle me-2"
          ></i>
          OK
        </b-button>
      </form>
    </b-modal>
  </div>
</template>
